export enum modalTypes {
	contact = 'contact',
	guarantorPopin = 'guarantorPopin',
	endPreReservation = 'endPreReservation',
	bedReservation = 'bedReservation',
	updateBedReservation = 'updateBedReservation',
	depositSent = 'depositSent',
	videoReader = 'videoReader',
	warningGuarantor = 'warningGuarantor',
	updateArrival = 'updateArrival',
	incompleteDossier = 'incompleteDossier',
	searchPopin = 'searchPopin',
	prolongationKO = 'prolongationKO',
	alreadyBooked = 'alreadyBooked',
	controlGuarantor = 'controlGuarantor',
	cguModal = 'cguModal',
}